module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: !_vm.isShowGallary ? '' : 'hidden-video'
  }, [_c('div', {
    staticClass: "video-wrap"
  }, [(_vm.data.showTitle === 'true') ? _c('div', {
    staticClass: "top-title mult_line_ellipsis"
  }, [_vm._v(_vm._s(_vm.data.title))]) : _vm._e(), _vm._v(" "), (_vm.data.liveType === 1 && _vm.data.status === 1) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.data.imageUrl,
      "alt": ""
    }
  }) : (_vm.data.liveType === 1 && _vm.data.status === 2) ? _c('video', {
    staticStyle: {
      "object-fit": "fill"
    },
    attrs: {
      "id": "liveId",
      "src": _vm.data.video,
      "poster": _vm.data.image,
      "controlsList": "nodownload",
      "x5-playsinline": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "x-webkit-airplay": "true",
      "x5-video-player-type": "h5",
      "controls": "",
      "preload": "auto",
      "x5-video-player-fullscreen": "",
      "x5-video-orientation": "portraint"
    }
  }) : (_vm.data.liveType === 1 && _vm.data.status === 3 && _vm.data.playback) ? _c('video', {
    staticStyle: {
      "object-fit": "fill"
    },
    attrs: {
      "id": "liveId",
      "src": _vm.data.playback,
      "poster": _vm.data.image,
      "controlsList": "nodownload",
      "x5-playsinline": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "x-webkit-airplay": "true",
      "x5-video-player-type": "h5",
      "controls": "",
      "preload": "auto",
      "x5-video-player-fullscreen": "",
      "x5-video-orientation": "portraint"
    }
  }) : (_vm.data.liveType === 1 && _vm.data.status === 3 && !_vm.data.playback) ? [_vm._v("\n                该直播已结束\n            ")] : _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.data.image,
      "alt": ""
    }
  })], 2), _vm._v(" "), _c('nav', {
    staticClass: "flex"
  }, [_vm._l((_vm.linkList), function(li, index) {
    return _c('div', {
      key: index,
      class: {
        activeItem: _vm.activeIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.routerPush(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(li.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })], 2), _vm._v(" "), _c('section', [(!_vm.activeIndex) ? _c('Room', {
    on: {
      "handleGallary": _vm.handleGallary
    }
  }) : _c('Interactive', {
    on: {
      "handleGallary": _vm.handleGallary
    }
  })], 1)]), _vm._v(" "), (_vm.isShowGallary) ? _c('div', {
    staticClass: "gallary-container"
  }, [_c('span', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.closeGallary
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "gallary-img",
    attrs: {
      "src": _vm.gallaryImg,
      "alt": ""
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79cd47af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-live2.vue
// module id = 860
// module chunks = 2